import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SummaryComponent from './summary';
import { MatchSummaryComponent, BriefScorecardComponent } from './matchsummary';
import ScorecardComponent from './scorecard';
import CommentaryComponent from './commentary';
import ApiService from 'services/index';
import LoadingBar from 'components/LoadingBar';
import { Tabs, Tab } from 'react-bootstrap';

const LiveCoverage = () => {
    const [liveMatch, setLiveMatch] = useState({});
    const [isMatchOver, setIsMatchOver] = useState(false);
    const { matchId } = useParams();

    const [firstLoad, setFirstLoad] = useState(true);
    const [selectedTab, setSelectedTab] = useState('summary');
    const [subtab, setSubtab] = useState('');
    const [chartTab, setChartTab] = useState('worm');
    const [subCommTab, setSubCommTab] = useState('inning-1-commentary-tab');
    const [subScoreTab, setSubScoreTab] = useState('inn0-sc-tab');
    const [hideBriefSummary, setHideBriefSummary] = useState(false);

    const runColors = {
        "1": "#fff",
        "2": "#fcff1e",
        "3": "#2fff9c",
        "4": "#19c1f7",
        "5": "#dba5ff",
        "6": "#ffb22e",
        "W": "#F44"
    };


    useEffect(() => {

        // Flag to track if an API call is in progress
        let isFetchingData = false;

        const fetchData = async () => {
            try {
                if (matchId && !isFetchingData && !isMatchOver) {

                    // Set the flag to indicate that an API call is in progress
                    isFetchingData = true;

                    let response = await ApiService.getLiveMatchData(matchId.trim());
                    if (response && response.live && response.live.length) {
                        const match = response.live[0];
                        if (match) {
                            const parsedData = JSON.parse(match.live_data);
                            if (parsedData?.meta?.matchOver) {
                                setIsMatchOver(true);
                                setLiveMatch(parsedData);
                            } else {
                                setLiveMatch(parsedData);
                            }
                        }
                    }

                    // Reset the flag when the API call is completed
                    isFetchingData = false;
                }
            } catch (error) {
                // Handle error
                console.log(error);
            }
        };

        fetchData();

        const intervalId = setInterval(fetchData, 10000);

        return () => {
            clearInterval(intervalId);
        };
    }, [matchId, isMatchOver]);

    if (Object.keys(liveMatch).length > 0) {
        return (
            <div className="container livecoverage">
                <h1>Live Coverage of  vs </h1>
                 <MatchSummaryComponent fullMatch={liveMatch.fullMatch} meta={liveMatch.meta} innings={liveMatch.innings} summary={liveMatch.summary} />
              <Tabs
                activeKey={selectedTab}
                onSelect={(key) => setSelectedTab(key)}
                id="live-coverage-tabs"
                className="nav-tabs"
              >
                <Tab eventKey="summary" title="Summary" id='summary-tab'>
                 
                  <BriefScorecardComponent summary={liveMatch.summary} />
                  <SummaryComponent ballByBall={liveMatch.ballByBall} hideBriefSummary={hideBriefSummary} />
                </Tab>
                <Tab eventKey="commentary" title="Commentary">
                  <CommentaryComponent  meta={liveMatch.meta} ballByBall={liveMatch.ballByBall} scorer={liveMatch.scorer}  />
                </Tab>
                <Tab eventKey="scorecard" title="Scorecard">
                  {/*  <ScorecardComponent t1n={"TODO"} t2n={"TODO"} scData={liveMatch.innings}/>*/}
                </Tab>
                <Tab eventKey="stats" title="Stats">
                  <div className="stat-content">
                    {/* Implement your stats content here */}
                  </div>
                </Tab>
              </Tabs>
            </div>
          );
    } else {
        <LoadingBar show={true} />
    }
};

export default LiveCoverage;
